import eventLib from './index';

/* 移除navigate监听 */
export function removeNavigate(callback) {
  eventLib.remove('navigate', callback);
}

/* 移除remind监听 */
export function removeDownloadRemind(callback) {
  eventLib.remove('remind', callback);
}
